import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';

export interface IGetGuestPublicConfigUseCase {
    execute(url: string): Promise<unknown | null>;
}

export class GetGuestPublicConfigUseCase implements IGetGuestPublicConfigUseCase {
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    async execute(url: string): Promise<unknown | null> {
        return this.authRepo.getGuestPublicConfig(url);
    }
}
